import React from "react";

const variants = {
  // The text colors keep 4.5:1 on their background (WCAG AA): red-700 on red-50, white on emerald-700 and amber-700.
  error:
    "bg-red-50 text-red-700 ring-1 ring-inset ring-red-200 enabled:hover:bg-red-600 enabled:hover:text-white enabled:hover:ring-red-600",
  "error-solid":
    "bg-red-600 text-white shadow-sm shadow-red-600/20 enabled:hover:bg-red-700",
  secondary:
    "bg-slate-100 text-slate-700 enabled:hover:bg-slate-200 enabled:hover:text-slate-900",
  "secondary-solid":
    "bg-slate-600 text-white shadow-sm enabled:hover:bg-slate-700",
  "secondary-outline":
    "bg-white text-slate-700 shadow-sm ring-1 ring-inset ring-slate-300 enabled:hover:bg-slate-50 enabled:hover:text-slate-900",
  success:
    "bg-emerald-700 text-white shadow-sm shadow-emerald-700/20 enabled:hover:bg-emerald-800",
  "success-simple":
    "bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-200 enabled:hover:bg-emerald-600 enabled:hover:text-white enabled:hover:ring-emerald-600",
  primary:
    "bg-blue-600 text-white shadow-sm shadow-blue-600/25 enabled:hover:bg-blue-700 enabled:hover:shadow-md enabled:hover:shadow-blue-600/25",
  "primary-solid":
    "bg-blue-600 text-white shadow-sm shadow-blue-600/25 enabled:hover:bg-blue-700",
  "landing-purple": "bg-[#813BE2] text-white",
  warning:
    "bg-amber-700 text-white shadow-sm shadow-amber-700/20 enabled:hover:bg-amber-800",
};

const defaultVariant =
  "bg-blue-50 text-blue-700 enabled:hover:bg-blue-600 enabled:hover:text-white";

export function Button({
  text,
  color,
  loading,
  disabled,
  children,
  Icon,
  className,
  ...rest
}) {
  return (
    <button
      className={`group relative inline-flex h-10 items-center justify-center gap-1 overflow-hidden rounded-lg px-5 py-1 text-sm font-medium
        transition duration-200 ease-out
        focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600
        enabled:active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none
      ${variants[color] || defaultVariant} ${className}`}
      // While loading, the click's request is still in flight; a second click would send it again.
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? undefined : Icon ? <Icon className="h-5" /> : undefined}
      {loading ? (
        <svg
          role="status"
          className="m-auto inline h-5 w-5 animate-spin"
          viewBox="0 0 24 24"
          fill="none"
        >
          <circle
            cx="12"
            cy="12"
            r="9"
            stroke="currentColor"
            strokeWidth="3"
            className="opacity-30"
          />
          <path
            d="M21 12a9 9 0 0 0-9-9"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      ) : children ? (
        children
      ) : (
        text
      )}
    </button>
  );
}
